import React from "react";
import "../scss/Footer.scss";
// @ts-ignore
import Logo from "../Assets/Images/seekhologo.webp";
// @ts-ignore
import fb from "../Assets/Images/fb.webp";
// @ts-ignore
import Youtube from "../Assets/Images/youtube-icon.webp";
// @ts-ignore
import insta from "../Assets/Images/instaIcon.webp";
import { Link } from "react-router-dom";

const Footer: React.FC = () => {
  return (
    <>
      <div className="container-fluid footer-container">
        <div className="container sub-container">
          <div className="logo-div">
            <img src={Logo} width="200px" height="60px" alt="Logo" />
          </div>
          <div className="terms-container">
            {/* <span>
              <Link to="faqs" target="_top">
                FAQs
              </Link>
            </span> */}
            <span>
              <Link to="/privacypolicy" target="_top">
                Privacy Policy
              </Link>
            </span>
            <span>
              <Link to="/terms" target="_top">
                Terms & Conditions
              </Link>
            </span>
            <span>
              <Link to="/faqs" target="_top">
                Faqs
              </Link>
            </span>
          </div>
          <div className="line-div-mobile"></div>
          <div className="icons-container">
            <span>
              <a
                href="https://www.facebook.com/profile.php?id=61589560892805"
                target="_blank"
                rel="noreferrer"
              >
                <img src={fb} width="28px" height="28px" alt="Facebook" />
              </a>
            </span>
            <span>
              <a
                href="https://www.instagram.com/sekho.digital/"
                target="_blank"
                rel="noreferrer"
              >
                <img src={insta} width="28px" height="28px" alt="Instagram" />
              </a>
            </span>
            <span>
              <a
                href="https://wa.me/923268469641"
                target="_blank"
                rel="noreferrer"
              >
                <WhatsappIcon size={28} />
              </a>
            </span>
            <span>
              <a
                href="mailto:support@celsius.cc"
                rel="noreferrer"
              >
                <MailIcon size={28} />
              </a>
            </span>
            {/* <span>
              <a
                href="https://play.google.com/store/apps/details?id=com.jazzeducator"
                target="_blank"
                rel="noreferrer"
              >
                <img src={Youtube} width="28px" height="28px" alt="Youtube" />
              </a>
            </span> */}
          </div>
        </div>
        <div className="line-div"></div>
        <div className="footer-heading-div">
          <div className="c-icon">c</div>
          <div className="heading">
            Copyright 2026, All Rights Reserved by Sekho
          </div>
        </div>
      </div>
    </>
  );
};
export default Footer;

// WhatsappIcon.jsx
export const WhatsappIcon = ({ size = 64, iconColor = "#B0021D", bgColor = "#FFFFFF" }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="32" cy="32" r="32" fill={bgColor} />
    <path
      d="M32 16c-8.8 0-16 7.2-16 16 0 2.8.7 5.5 2.1 7.9L16 48l8.3-2.2c2.3 1.3 4.9 2 7.7 2 8.8 0 16-7.2 16-16s-7.2-16-16-16zm0 29.2c-2.4 0-4.7-.6-6.7-1.8l-.5-.3-5 1.3 1.3-4.9-.3-.5c-1.3-2.1-2-4.5-2-7 0-7.3 5.9-13.2 13.2-13.2S45.2 24.7 45.2 32 39.3 45.2 32 45.2z"
      fill={iconColor}
    />
    <path
      d="M39.4 35.4c-.4-.2-2.4-1.2-2.8-1.3-.4-.1-.6-.2-.9.2-.3.4-1 1.3-1.2 1.5-.2.2-.4.3-.8.1-.4-.2-1.6-.6-3.1-1.9-1.1-1-1.9-2.3-2.1-2.7-.2-.4 0-.6.2-.8.2-.2.4-.4.6-.6.2-.2.3-.4.4-.6.1-.2.1-.5 0-.7-.1-.2-.9-2.2-1.2-3-.3-.8-.7-.7-.9-.7h-.8c-.3 0-.7.1-1 .5-.4.4-1.4 1.3-1.4 3.3s1.4 3.8 1.6 4.1c.2.3 2.8 4.3 6.8 6 .9.4 1.7.6 2.2.8.9.3 1.8.3 2.5.2.8-.1 2.4-1 2.7-1.9.3-.9.3-1.7.2-1.9-.1-.2-.3-.3-.7-.5z"
      fill={iconColor}
    />
  </svg>
);

// MailIcon.jsx
export const MailIcon = ({ size = 64, iconColor = "#B0021D", bgColor = "#FFFFFF" }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="32" cy="32" r="32" fill={bgColor} />
    <rect x="16" y="20" width="32" height="24" rx="3" stroke={iconColor} strokeWidth="2.5" />
    <path
      d="M17 22l15 12 15-12"
      stroke={iconColor}
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);